var map = {
	"./Herman-Lindqvist.jpg": 3789,
	"./Jinder.jpg": 8883,
	"./bellmandagen.jpg": 7901,
	"./calaisa.jpg": 7917,
	"./eric_1000.jpg": 2452,
	"./malena_mats.jpg": 9729,
	"./midsommar.jpg": 3336,
	"./schaffer.jpg": 9377,
	"./säsongsöppning.jpg": 5664,
	"./tina_bengan.jpg": 209
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2808;